import type {
  AuthenticateAppRequest,
  AuthenticateOtpRequest,
  AuthenticateRequest,
  AuthenticateVerifyTokenRequest,
  AuthenticationRepsone,
} from "@/models/auth";

export const authWithSim = async (
  authRequest: AuthenticateRequest
): Promise<AuthenticationRepsone> => {
  const url = `/api/onboarding/sim`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(authRequest),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    if (data && !data.code) {
      throw new Error(`No auth code, try Auðkenni app instead`);
    }
    return data;
  } catch (error) {
    console.error(`authenticate: ${error}`);
    throw error;
  }
};

//TODO: FIX
export const authWithApp = async (
  authRequest: AuthenticateAppRequest
): Promise<AuthenticationRepsone> => {
  const url = `/api/onboarding/app`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(authRequest),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`authenticate: ${error}`);
    throw error;
  }
};

export const authOtp = async (
  authRequest: AuthenticateOtpRequest
): Promise<void> => {
  const url = `/api/onboarding/otp`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(authRequest),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
  } catch (error) {
    console.error(`authenticate: ${error}`);
    throw error;
  }
};

export const verifyToken = async (
  authRequest: AuthenticateVerifyTokenRequest
): Promise<void> => {
  const url = `/api/onboarding/verify-token`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(authRequest),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
  } catch (error) {
    console.error(`authenticate: ${error}`);
    throw error;
  }
};

export const getAuthStatus = async (
  id: string
): Promise<{ status: string }> => {
  const url = `/api/onboarding/status/${id}`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getAuthStatus exception: ${error}`);
    throw error;
  }
};
